export interface ManualEmailField {
	name: string;
	label: string;
	multiline?: boolean;
	defaultValue?: string;
}

export interface ManualEmailType {
	value: string;
	label: string;
	fields: ManualEmailField[];
}

// Keep in sync with EMAIL_TYPES in gpm notifications/email_templates.py
export const MANUAL_EMAIL_TYPES: ManualEmailType[] = [
	{
		value: 'manual',
		label: 'Manual',
		fields: [
			{ name: 'title', label: 'Title', defaultValue: 'Test email' },
			{
				name: 'content',
				label: 'Content',
				multiline: true,
				defaultValue: 'This is a test email.'
			}
		]
	},
	{
		value: 'verification_email_link',
		label: 'Verification email link',
		fields: [
			{
				name: 'url',
				label: 'Verification URL',
				defaultValue: 'https://portal.ecivis.com/verify/test-token'
			}
		]
	},
	{
		value: 'deadline_reminder',
		label: 'Deadline reminder',
		fields: [
			{ name: 'program_name', label: 'Program name', defaultValue: 'Test Program' },
			{ name: 'deadline', label: 'Deadline', defaultValue: '2026-12-31' },
			{ name: 'url', label: 'URL', defaultValue: 'https://portal.ecivis.com' }
		]
	}
];

export const DEFAULT_MANUAL_EMAIL_TYPE = MANUAL_EMAIL_TYPES[0].value;

// Prefill for debugging; users can edit the values before sending
export const getDefaultContext = (typeValue: string): Record<string, string> =>
	Object.fromEntries(
		(MANUAL_EMAIL_TYPES.find((emailType) => emailType.value === typeValue)?.fields ?? []).map(
			(field) => [field.name, field.defaultValue ?? '']
		)
	);
